import React from 'react';
import type { SessionScreen } from '../../../features/flow/session';
import { getIllustrationSrc } from '../../../features/flow/utils';

export function IllustrationScreenBody({
  sessionScreen,
  title,
}: {
  sessionScreen: SessionScreen;
  title: string;
}) {
  const bulletListMaxWClass =
    sessionScreen.screen_id === 'what_to_expect' ? 'max-w-[374px]' : 'max-w-[510px]';

  return (
    <>
      <div className="w-full flex justify-center">
        <img
          src={getIllustrationSrc(sessionScreen)}
          alt={sessionScreen.screen_id}
          className="w-[200px] h-[200px] object-contain"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>

      <div className="flex flex-col text-center items-center self-stretch gap-[24px]">
        <h1 className="text-lg md:text-[22px] lg:text-2xl font-medium md:font-semibold text-[#131315]">{title}</h1>

        {sessionScreen.screen_id === 'welcome' && sessionScreen.subtitle?.trim() ? (
          <p className="text-[#525353] text-sm w-full max-w-[502px] font-medium">{sessionScreen.subtitle}</p>
        ) : null}

        {sessionScreen.paragraphs && sessionScreen.paragraphs.length > 0 ? (
          <div className="text-[#525353] text-sm w-full max-w-[370px] font-medium space-y-3 text-center">
            {sessionScreen.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        ) : null}

        {sessionScreen.bullet_points && sessionScreen.bullet_points.length > 0 ? (
          <p className={`text-[#525353] w-full ${bulletListMaxWClass} text-left`}>
            <ol className="list-decimal list-inside space-y-1 text-sm font-medium">
              {sessionScreen.bullet_points.map((point, i) => (
                <li key={`${i}:${point}`}>{point}</li>
              ))}
            </ol>
          </p>
        ) : null}
      </div>
    </>
  );
}
